import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { IPaginationResult } from 'app/common/interfaces/pagination-result.interface';
import VehicleAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity';
import { VechicleService } from '../../transport/vechicle/vehicle.service';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import VehicleTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle-type/vehicle-type.entity';

@Component({
  selector: 'app-vehicles-filters',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    FormsModule,
  ],
  templateUrl: './vehicles-filters.component.html',
  styleUrls: ['./vehicles-filters.component.scss']
})
export class VehiclesFiltersComponent {
  @Input() form!: FormGroup;
  @Input() vehicleTypeList: VehicleTypeAttributes[] = [];
  @Input() vehicle: boolean = false;
  @Input() loadData: boolean = undefined;

  @ViewChild(MatSelect, { static: false }) public matSelect: MatSelect;

  getCode = getCode;
  vechicleList: VehicleAttributes[] = []
  filteredvechicleList: VehicleAttributes[] = [];

  constructor(
    private vechicleService: VechicleService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      this.loadAllData();
    }
  }

  ngOnInit() {   
    if (this.loadData === undefined) {
      this.loadAllData();
    }

    this.form.get('searchVehicles')?.valueChanges
    .subscribe(search => {
      this.getVehicles(search);
    });
  }

  private loadAllData(): void {
    if (this.vehicle) {this.getAllVehicles();}
  }

  getDisplayValue(list: any[], selectedIds: any[], key: string): string {
    if (!selectedIds || selectedIds.length === 0) return '';
    return list
      .filter(item => selectedIds.includes(item._id))
      .map(item => item[key])
      .join(', ');
  }

  getAllVehicles() {
    let options = { currentPage: 1, limitPerPage: 50 }

    this.vechicleService.getAllPaginateVehicle(options
    ).subscribe({
      next: (res: IPaginationResult<VehicleAttributes>) => {
        this.vechicleList = res?.data?.[0]?.data ?? [];
        this.filteredvechicleList = res?.data?.[0]?.data ?? [];
      }
    })
  }

  getVehicles(search: string) {
    const selectedIds = this.form.get('vehicleId')?.value || [];
    const value = search?.toLowerCase() ?? '';

    if (!value) {
      const seleccionados = this.vechicleList.filter(item => selectedIds.includes(item._id));
      const noSeleccionados = this.vechicleList.filter(item => !selectedIds.includes(item._id));
      const ordenada = [...seleccionados, ...noSeleccionados];

      this.filteredvechicleList = ordenada;
      this.vechicleList = ordenada;
      return;
    }


    let options = { currentPage: 1, limitPerPage: 50, search: search }

    this.vechicleService.getAllPaginateVehicle(options
    ).subscribe({
      next: (res: IPaginationResult<VehicleAttributes>) => {
        // this.vechicleList = res?.data?.[0]?.data ?? [];
        // this.filteredvechicleList = res?.data?.[0]?.data ?? [];

        const news = res?.data?.[0]?.data ?? [];

        const mapaForId = new Map<string, VehicleAttributes>();

        this.vechicleList.forEach(item => {
          mapaForId.set(item._id.toString(), item);
        });

        news.forEach(item => {
          mapaForId.set(item._id.toString(), item);
        });


        this.vechicleList = Array.from(mapaForId.values());


        const seleccionados = this.vechicleList.filter(item => selectedIds.includes(item._id));
        const noSeleccionados = this.vechicleList.filter(item => !selectedIds.includes(item._id));
        const ordenada = [...seleccionados, ...noSeleccionados];

        if (value === '') {
          this.filteredvechicleList = ordenada;
        } else {
          this.filteredvechicleList = ordenada.filter(item =>
            item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
          );
        }

        this.vechicleList = ordenada;
      }
    })
  }

  getDisplayValueForMongoId(list: VehicleAttributes[], ids: string[], field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id.toString()))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item._id === ids);
      return found?.[field] ?? '';
    }
  }

}
